import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';
import { PlacementAgentInstitutionsParams } from '../Models';

export const InstitutionsAPI = (baseURL: string |undefined, baseURLExternal: string |undefined, clientId: string) => {
    const apiConfig = {
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    };
    const bookbuildingAPI = AxiosAPI({ ...apiConfig });
    const externalsAPI = AxiosAPI({ ...apiConfig, baseURL: baseURLExternal });

    const getInvestorInstitutions = () => {
        const serviceUrl = `/masters-api/Institution/GetInvestorInstitutions`;
        return externalsAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getPlacementAgentInstitutions = (params: PlacementAgentInstitutionsParams) => {
        const serviceUrl = `/masters-api/Institution/GetInstitutionsOfPlacementAgent`;
        return externalsAPI.get(serviceUrl, { params })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getAdministrationPlacementAgentInstitutions = () => {
        const serviceUrl = `/masters-api/Institution/GetPlacementAgentInstitutions`;
        return externalsAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getInvestorStatusEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetInvestorStatusEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getRepresentativesPFEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetRepresentativesPFEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getSuitabilityTestEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetSuitabilityTestEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getSuitabilityTestConfiguration = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetSuitabilityTestConfiguration`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getInvestorWithoutNIFEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetInvestorWithoutNIFEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getCRSEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetCRSEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getFATCAEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetFATCAEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getIncludesBeneficiariesGreater5BBEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetIncludesBeneficiariesGreater5BBEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getIncludesRegistrationNumberEnabled = (idInstitution: number, idVehicle: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetIncludesRegistrationNumberEnabled`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getVehiclesByInstitution = (idInstitution: number) => {
        const serviceUrl = `/bookbuilding-api/Institution/GetVehiclesByInstitution`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    return {
        getInvestorInstitutions,
        getAdministrationPlacementAgentInstitutions,
        getPlacementAgentInstitutions,
		getSuitabilityTestEnabled,
		getSuitabilityTestConfiguration,
		getVehiclesByInstitution,
        getInvestorStatusEnabled,
        getRepresentativesPFEnabled,
        getInvestorWithoutNIFEnabled,
        getCRSEnabled,
        getFATCAEnabled,
        getIncludesBeneficiariesGreater5BBEnabled,
        getIncludesRegistrationNumberEnabled
	};
};
